import * as React from "react";

import { ErrorPage } from "Components/ErrorPage";
import { IllustrationName } from "Constants/constants";
import { TextLanguage } from "Store/texts/interfaces";

interface Props {
  readonly texts: any;
  readonly lang: TextLanguage;
}

export const CustomerTooYoung = (props: Props): React.ReactElement => {
  const { texts, lang } = props;
  return (
    <ErrorPage
      illustrationName={IllustrationName.CUSTOMER_SERVICE_WOMAN}
      title={texts.tooYoung.header[lang]}
      paragraphs={[texts.tooYoung.desc[lang]]}
    />
  );
};
